// assets/cart-guard.js - Anti-Duplikat-Mechanismus (v2 - mit Preis-Check)

(() => {
  let cartUpdateInProgress = false;
  let pendingCartRefresh = false;
  let lastCartState = null;
  let refreshTimeout = null;

  // Wartet bis Cart-Update fertig ist
  function waitForCartUpdate() {
    return new Promise((resolve) => {
      const checkInterval = setInterval(() => {
        if (!cartUpdateInProgress) {
          clearInterval(checkInterval);
          resolve();
        }
      }, 100);
    });
  }

  // Holt aktuellen Cart-Status
  async function getCartState() {
    try {
      const response = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      });
      return await response.json();
    } catch (e) {
      console.error('Cart Guard: Fehler beim Abrufen des Carts', e);
      return null;
    }
  }

  // Entfernt Duplikate aus dem Cart (mit Preis-Check!)
  async function removeDuplicates(cart) {
    const seen = new Map();
    const duplicates = [];

    cart.items.forEach((item, index) => {
      // Eindeutiger Key: Variant-ID + Preis (damit €0 und €1,50 unterschieden werden)
      const key = `${item.variant_id}_${item.final_price}`;
      
      if (seen.has(key)) {
        // Echtes Duplikat gefunden (gleiche Variant + gleicher Preis)
        duplicates.push({ 
          line: index + 1, 
          variant_id: item.variant_id,
          price: item.final_price,
          title: item.product_title
        });
      } else {
        seen.set(key, index + 1);
      }
    });

    if (duplicates.length === 0) return false;

    console.log('Cart Guard: Duplikate gefunden, entferne...', duplicates);

    // Entferne Duplikate sequenziell
    for (const dup of duplicates) {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: dup.line,
            quantity: 0
          })
        });
        await new Promise(resolve => setTimeout(resolve, 200));
      } catch (e) {
        console.error('Cart Guard: Fehler beim Entfernen von Duplikat', e);
      }
    }

    return true;
  }

  // Überwacht Cart auf Änderungen
  async function checkForDuplicates() {
    if (cartUpdateInProgress) {
      pendingCartRefresh = true;
      return;
    }

    const cart = await getCartState();
    if (!cart) return;

    const removed = await removeDuplicates(cart);
    
    if (removed) {
      // Warte kurz und aktualisiere dann den Drawer
      await new Promise(resolve => setTimeout(resolve, 300));
      refreshCartDrawer();
    }

    lastCartState = cart;
  }

  // Aktualisiert Cart Drawer
  function refreshCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer-items');
    if (cartDrawer && typeof cartDrawer.onCartUpdate === 'function') {
      cartDrawer.onCartUpdate();
    }
  }

  // Überwacht Cart-Updates
  function observeCartUpdates() {
    // Überwache Quantity-Änderungen
    document.addEventListener('click', (e) => {
      const target = e.target;
      if (target.closest('.quantity__button') || 
          target.closest('.cart-remove-button') ||
          target.closest('[name="updates[]"]')) {
        
        cartUpdateInProgress = true;
        
        clearTimeout(refreshTimeout);
        refreshTimeout = setTimeout(async () => {
          cartUpdateInProgress = false;
          await checkForDuplicates();
          
          if (pendingCartRefresh) {
            pendingCartRefresh = false;
            await checkForDuplicates();
          }
        }, 800);
      }
    });

    // Überwache Input-Änderungen
    document.addEventListener('change', (e) => {
      if (e.target.matches('[name="updates[]"]')) {
        cartUpdateInProgress = true;
        
        clearTimeout(refreshTimeout);
        refreshTimeout = setTimeout(async () => {
          cartUpdateInProgress = false;
          await checkForDuplicates();
        }, 800);
      }
    });

    // Überwache Cart-Drawer-Öffnung
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.target.classList && mutation.target.classList.contains('active')) {
          setTimeout(checkForDuplicates, 500);
        }
      });
    });

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      observer.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  // Initialisierung
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      observeCartUpdates();
      setTimeout(checkForDuplicates, 1000);
    });
  } else {
    observeCartUpdates();
    setTimeout(checkForDuplicates, 1000);
  }

  // Periodische Überprüfung (alle 3 Sekunden wenn Drawer offen)
  setInterval(() => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.classList.contains('active')) {
      checkForDuplicates();
    }
  }, 3000);

  // Exportiere für externe Nutzung
  window.CartGuard = {
    check: checkForDuplicates,
    refresh: refreshCartDrawer
  };
})();
